if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('totals__total-value')) {
            window.initDCBox()
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  let counter = 0;
let selector = "#bss-b2b-register-form"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);
        
        const btn = document.querySelector(
          '#bss-b2b-register-form input[type="submit"]'
        );

        const wrapper = document.querySelector(
          '.bss-b2b-rf-submit-button'
        );

        if (!btn || !wrapper) return;

        btn.addEventListener("click", () => {

          // chờ BSS validate xong
          setTimeout(() => {

            const hasError = [
              ...document.querySelectorAll(
                '#bss-b2b-register-form .bss-message'
              )
            ].some(el => el.textContent.trim() !== "");

            // nếu có lỗi required thì ko loading
            if (hasError) {
              wrapper.classList.remove("bss-submit-loading");
              return;
            }

            // tránh click nhiều lần
            if (wrapper.classList.contains("bss-submit-loading")) return;

            wrapper.classList.add("bss-submit-loading");

            // fallback
            setTimeout(() => {
              wrapper.classList.remove("bss-submit-loading");
            }, 8000);

          }, 50);

        });

    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 

